"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnimatedComponent = void 0;

var _react = _interopRequireDefault(require("react"));

var _server = _interopRequireDefault(require("react-dom/server"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactReplaceHtml = _interopRequireDefault(require("react-replace-html"));

var _reactSpring = require("react-spring");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var AnimatedComponent = function AnimatedComponent(_ref) {
  var type = _ref.type,
      animatedTarget = _ref.animatedTarget,
      animatedConfigAry = _ref.animatedConfigAry;
  var AnimatedElement = animatedTarget; // Convet html to string

  var htmlString;

  if (type === 'svg') {
    htmlString = _server.default.renderToString( /*#__PURE__*/_react.default.createElement(AnimatedElement, null));
  } else if (type === 'default') {
    htmlString = _server.default.renderToString(animatedTarget);
  } // Replace AnimatedElement


  function ReplaceToAnimatedComponent(props) {
    var _useSpring = (0, _reactSpring.useSpring)(function () {
      return {
        to: props.tarObj.to,
        from: props.tarObj.from,
        loop: props.tarObj.loop,
        delay: props.tarObj.delay,
        config: props.tarObj.config,
        ref: props.tarObj.ref,
        pause: props.tarObj.pause,
        cancel: props.tarObj.cancel,
        onRest: props.tarObj.onRest,
        reverse: props.tarObj.reverse
      };
    }),
        _useSpring2 = _slicedToArray(_useSpring, 2),
        aniProps = _useSpring2[0],
        set = _useSpring2[1];

    set({
      transform: 'scale(0.6)'
    });
    var svgProps = {
      id: props.id,
      className: props.class,
      cx: props.cx,
      cy: props.cy,
      d: aniProps.d ? aniProps.d : props.d,
      r: props.r,
      fill: aniProps.fill ? aniProps.fill : props.fill,
      points: aniProps.points ? aniProps.points : props.points,
      transform: aniProps.transform ? aniProps.transform : props.transform,
      opacity: aniProps.opacity ? aniProps.opacity : props.opacity,
      strokeWidth: aniProps.strokeWidth ? aniProps.strokeWidth : props['stroke-width'],
      strokeDasharray: aniProps.strokeDasharray ? aniProps.strokeDasharray : props.strokeDasharray,
      strokeDashoffset: aniProps.strokeDashoffset ? aniProps.strokeDashoffset : props.strokeDashoffset,
      strokeLinecap: aniProps.strokeLinecap ? aniProps.strokeLinecap : props['stroke-linecap'],
      strokeLinejoin: aniProps.strokeLinejoin ? aniProps.strokeLinejoin : props['stroke-linejoin'],
      stroke: aniProps.stroke ? aniProps.stroke : props.stroke,
      style: _objectSpread({}, props.tarObj.styles)
    };

    var animatedG = /*#__PURE__*/_react.default.createElement(_reactSpring.animated.g, svgProps, props.children);

    var animatedCircle = /*#__PURE__*/_react.default.createElement(_reactSpring.animated.circle, svgProps, props.children);

    var animatedPolyLine = /*#__PURE__*/_react.default.createElement(_reactSpring.animated.polyline, svgProps, props.children);

    var animatedPath = /*#__PURE__*/_react.default.createElement(_reactSpring.animated.path, svgProps, props.children);

    var animatedDiv = /*#__PURE__*/_react.default.createElement(_reactSpring.animated.div, {
      id: props.id,
      className: props.class,
      style: _objectSpread(_objectSpread({}, aniProps), props.tarObj.styles)
    }, props.children);

    switch (props.tag) {
      case 'g':
        return animatedG;

      case 'circle':
        return animatedCircle;

      case 'path':
        return animatedPath;

      case 'polyline':
        return animatedPolyLine;

      default:
        return animatedDiv;
    }
  }

  var isAnimatedComponent = function isAnimatedComponent(propID) {
    return animatedConfigAry.find(function (target) {
      return propID === target.id;
    });
  };

  var replacer = function replacer(tag, props) {
    if (isAnimatedComponent(props.id) !== undefined) {
      return /*#__PURE__*/_react.default.createElement(ReplaceToAnimatedComponent, _extends({
        tag: tag,
        tarObj: isAnimatedComponent(props.id)
      }, props));
    }

    return /*#__PURE__*/_react.default.createElement(tag, props);
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _reactReplaceHtml.default)(htmlString, replacer));
};

exports.AnimatedComponent = AnimatedComponent;
AnimatedComponent.propTypes = {
  type: _propTypes.default.string,
  animatedTarget: _propTypes.default.any,
  animatedConfigAry: _propTypes.default.array
};
AnimatedComponent.defaultProps = {
  type: 'default',
  animatedTarget: null,
  animatedConfigAry: []
};